const config = {
    api: "",
    brand: "stech"
};

//Brand Setup
if (document.location.href.indexOf("s-tech") > -1) {
    config.brand = "stech";
    document.title = "Your Credit Agreement | S-Tech";
    document.querySelector('meta[name="description"]').setAttribute("content", "Your Credit Agreement | S-Tech");
} else {
    config.brand = "abg";
    document.title = "Your Credit Agreement | Alan Boswell Group";
    document.querySelector('meta[name="description"]').setAttribute("content", "Your Credit Agreement | Alan Boswell Group");
}

console.log('brand:', config.brand);

export default config;